import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa';
import Cookies from 'js-cookie';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import { BASE_URL } from '../config/constants';
function MyLearningLessons() {
	const token = Cookies.get('token');
	const location = useLocation();
	const { id } = useParams();
	const [lessons, setLessons] = useState([]);
	const [videoOfCourse, setVideoOfCourse] = useState('');
	const [loading, setLoading] = useState(true);
	const videoRef = useRef(null);
	const baseUrl = BASE_URL;
	useEffect(() => {
		fetch(`${baseUrl}/api/v1/courses/${id}`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setLessons(data.lessons);
				setVideoOfCourse(data.video.URL);
				setLoading(false);
			})
			.catch((err) => {
				console.error('Error fetching lessons data:', err);
				setLoading(false);
			});
	}, [location, id, token]);

	useEffect(() => {
		if (videoRef.current) {
			const player = new Plyr(videoRef.current, {
				controls: [
					'play-large',
					'restart',
					'rewind',
					'play',
					'fast-forward',
					'progress',
					'current-time',
					'duration',
					'mute',
					'volume',
					'captions',
					'settings',
					'pip',
					'airplay',
					'fullscreen',
				],
			});

			// Store the player instance to use later
			videoRef.current.player = player;

			return () => {
				player.destroy();
			};
		}
	}, [videoOfCourse]);

	if (loading) {
		return (
			<main className='h-[80vh] bg-main text-xl md:text-4xl text-white flex justify-center items-center'>
				Loading...
			</main>
		);
	}

	const videoId = videoOfCourse.split('/').pop();

	return (
		<>
			{lessons.length > 0 ? (
				<main className='py-4'>
					<div className='container bg-section flex flex-col md:flex-row-reverse gap-4 p-6'>
						{/* Video Section */}
						<section className='w-full md:w-4/6 justify-center rounded overflow-hidden'>
							<div className={`video-container relative`}>
								<div
									ref={videoRef}
									data-plyr-provider='youtube'
									data-plyr-embed-id={videoId}></div>
								{/* Fullscreen Toggle Button */}
							</div>
						</section>

						{/* Lessons List */}
						<aside className='w-full md:w-2/6 flex flex-col gap-1'>
							{lessons.map((lesson) => (
								<Link
									to={`/my-learning/${id}/${lesson.id}`}
									key={lesson.id}
									className='customLesson p-2 bg-main text-white rounded flex gap-2 items-center'>
									<div className='text-lg'>
										<FaYoutube />
									</div>
									<h2>{lesson.title}</h2>
								</Link>
							))}
							<Link
								to={`/my-learning/${id}/final-test`}
								className=' p-2 bg-main text-white rounded flex gap-2 items-center'>
								Final Test
							</Link>
						</aside>
					</div>
				</main>
			) : (
				<main className='h-[80vh] bg-main text-xl md:text-4xl text-white flex justify-center items-center'>
					No lessons Found
				</main>
			)}
		</>
	);
}

export default MyLearningLessons;
